import { createReducer } from '@reduxjs/toolkit';
import VideoStoreActions from './VideoStoreActions';
import { VideoStoreState } from './VideoStoreState';

const initialState: VideoStoreState = {};
export const videoStoreReducer = createReducer<VideoStoreState>(initialState, (builder) => {
  builder.addCase(VideoStoreActions.setVideoSource, (state, action) => ({ ...state, videoSource: action.payload }));
});
